import { lessons } from "@/data/content";
import { selectLesson } from "@/lib/events";
import { scrollToId } from "@/lib/scroll";

const items = lessons.map((l) => l[1]);

export const Marquee = () => {
  const jump = (title) => { selectLesson(title); scrollToId("library"); };
  return (
    <div className="marquee" data-testid="lesson-marquee">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div className="marquee-group" key={copy}>
            {items.map((t, i) => (
              <button type="button" className="marquee-item" key={`${copy}-${i}`} onClick={() => jump(t)} tabIndex={copy ? -1 : 0} data-testid={`marquee-item-${i}`}><i /> {t}</button>
            ))}
          </div>
        ))}
      </div>
      <span className="marquee-hint">Tap any lesson to open it</span>
    </div>
  );
};
